module.exports = {
  validate: function (form) {
    return new Promise((resolve, reject) => {
      form.check(resolve)
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/form.js